// | Transport type for Aeson.Value.
// |
// | Value is uninterpreted by the server, hence here it's just a
// | `Foreign` value (`Aeson.Value` on Higgs side).
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Value = x => x;
const udecodeValue = Unscramble.decodeForeign;
const showValue = {
  show: v => {
    if (Foreign.isUndefined(v)) { return "\"undefined\""; }
    if (Foreign.isNull(v)) { return "\"null\""; }
    return Data$dShow.showStringImpl(Foreign$dInternal$dStringify.unsafeStringify(v));
  }
};
const newtypeValue = {Coercible0: () => {}};
const encodeValue = Foreign$dGeneric$dClass.foreignEncode;
const eqValue = {eq: x => y => Foreign$dInternal$dStringify.unsafeStringify(x) === Foreign$dInternal$dStringify.unsafeStringify(y)};
const decodeValue = Foreign$dGeneric$dClass.foreignDecode;
export {Value, decodeValue, encodeValue, eqValue, newtypeValue, showValue, udecodeValue};
